import { AxiosPromise, CancelToken } from 'axios';
import { DetectionFilterCriteria } from 'Models/Videos/Detections/DetectionFilterCriteria';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

const postMatchingDetectionsRequest = (
	token: string | null,
	videoId: number,
	criteria: DetectionFilterCriteria,
	cancelToken?: CancelToken
): AxiosPromise<number[]> => {
	const url = getApiUrl(ApiUrl.VideosVideoDetectionsMatching).replace(':videoId', videoId.toString());
	return getAxiosInstance(token).post(url, criteria, { cancelToken });
};

export default postMatchingDetectionsRequest;
